// initial state
import axios from "axios";

const state = () => ({
    users: [],
    currencies: [],
    countries: [],
    bank_accounts: []
})

// getters
const getters = {}

// actions
const actions = {
    async getData ({ commit }, params = {}) {
        const result = await axios.get(route('admin.offices.getData', {current_user_id: params.currentUserId ?? null}))

        commit('setUsers', result.data.users)
        commit('setCurrencies', result.data.currencies)
        commit('setCountries', result.data.countries)
        commit('setBankAccounts', result.data.bank_accounts)
    }
}

// mutations
const mutations = {
    setUsers (state, users) {
        state.users = users
    },
    setCurrencies (state, currencies) {
        state.currencies = currencies
    },
    setCountries (state, countries) {
        state.countries = countries
    },
    setBankAccounts(state, bank_accounts) {
        state.bank_accounts = bank_accounts
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
